import JourneyMap from './component';

export default JourneyMap;
